import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=6f2c36da&scoped=true&"
import script from "./top-header.vue?vue&type=script&lang=ts&"
export * from "./top-header.vue?vue&type=script&lang=ts&"
import style0 from "./top-header.vue?vue&type=style&index=0&id=6f2c36da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c36da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2c36da')) {
      api.createRecord('6f2c36da', component.options)
    } else {
      api.reload('6f2c36da', component.options)
    }
    module.hot.accept("./top-header.vue?vue&type=template&id=6f2c36da&scoped=true&", function () {
      api.rerender('6f2c36da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/top-header.vue"
export default component.exports